import * as yup from "yup";

export const userSchema = yup.object().shape({
    firstname: yup.string().required(),
    lastname: yup.string().required(),
    phone: yup.string(),
})
